<script setup lang="ts">
/**
 * Singbac — Company's Structure Chart (UBO → Company 지분 구조). company 단위 1부.
 */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-sec-title">COMPANY'S STRUCTURE CHART</div>

    <div class="chart">
      <div class="node"><CddVarField field-key="client_name" label="Client Name" /> (UBO)</div>
      <div class="edge">
        <span class="line">│</span>
        <span class="pct"><CddVarField field-key="ownership_percentage" label="Ownership %" /></span>
      </div>
      <div class="node"><CddVarField field-key="company_name" label="Company Name" /></div>
    </div>

    <div class="sig-line">______________________________</div>
    <p class="doc-p"><CddVarField field-key="client_name" label="Client Name" /></p>
    <p class="doc-p">Signed and approved</p>

    <p class="doc-p"><b>Dated:</b> <CddVarField field-key="chart_date" label="Chart Date" /></p>
  </div>
</template>

<style scoped>
.chart { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 24px 0 30px; }
.node { border: 1.5px solid #333; border-radius: 4px; padding: 10px 18px; font-weight: 700; text-align: center; min-width: 180px; }
.edge { display: flex; flex-direction: column; align-items: center; gap: 2px; }
.edge .line { font-size: 18px; line-height: 1; }
.edge .pct { font-size: 12px; }
.sig-line { font-family: monospace; margin-top: 18px; }
</style>
